import FileInput from './file_input';

export {
    FileInput
}